<template>
  <transition name="modal-fade">
    <div class="modal-overlay-gcn" v-if="show" @click.self="closePopup">
      <div class="modal-container-gcn modal-lg">
        <div class="modal-header-gcn">
          <h3>
            <span class="modal-icon material-icons-outlined">feedback</span>
            Encuesta sobre el Informe Semanal
          </h3>
          <button class="modal-close-btnGcn" @click="closePopup">×</button>
        </div>

        <div class="modal-body-gcn">
          <div class="survey-content">
            <p class="survey-intro">Tu opinión es muy importante para nosotros. Ayúdanos a mejorar nuestro informe semanal:</p>
            
            <!-- Sección 1: Secciones del informe -->
            <div class="survey-section">
              <h4 class="section-title">
                <span class="section-icon">📌</span>
                Secciones del informe
              </h4>
              
              <!-- Pregunta 1 -->
              <div class="question-group">
                <label class="question-label">
                  <span class="question-number">1</span>
                  ¿Cuál es tu sección favorita del informe?
                </label>
                <div class="radio-options">
                  <label class="radio-option" v-for="option in sectionOptions" :key="'fav_' + option.value">
                    <input type="radio" v-model="answers.favorite_section" :value="option.value" name="favorite_section">
                    <span class="radio-custom"></span>
                    <span class="option-text">{{ option.label }}</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="answers.favorite_section" value="other" name="favorite_section">
                    <span class="radio-custom"></span>
                    <span class="option-text">Otra (especificar)</span>
                    <input 
                      v-if="answers.favorite_section === 'other'" 
                      type="text" 
                      v-model="answers.favorite_section_other" 
                      class="other-input"
                      placeholder="Especifica cuál"
                      @click.stop>
                  </label>
                </div>
              </div>

              <!-- Pregunta 2 -->
              <div class="question-group">
                <label class="question-label">
                  <span class="question-number">2</span>
                  ¿Qué sección encuentras menos útil o interesante?
                </label>
                <div class="radio-options">
                  <label class="radio-option" v-for="option in sectionOptions" :key="'least_' + option.value">
                    <input type="radio" v-model="answers.least_useful_section" :value="option.value" name="least_useful_section">
                    <span class="radio-custom"></span>
                    <span class="option-text">{{ option.label }}</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="answers.least_useful_section" value="other" name="least_useful_section">
                    <span class="radio-custom"></span>
                    <span class="option-text">Otra (especificar)</span>
                    <input 
                      v-if="answers.least_useful_section === 'other'" 
                      type="text" 
                      v-model="answers.least_useful_section_other" 
                      class="other-input"
                      placeholder="Especifica cuál"
                      @click.stop>
                  </label>
                </div>
              </div>

              <!-- Pregunta 3 -->
              <div class="question-group">
                <label class="question-label">
                  <span class="question-number">3</span>
                  ¿Qué sección te gustaría que incluyéramos en el futuro?
                </label>
                <textarea 
                  v-model="answers.future_section" 
                  class="text-area"
                  placeholder="Describe la sección que te gustaría ver..."
                  rows="3">
                </textarea>
              </div>
            </div>

            <!-- Sección 2: Contenido y formato -->
            <div class="survey-section">
              <h4 class="section-title">
                <span class="section-icon">🎨</span>
                Contenido y formato
              </h4>
              
              <!-- Pregunta 4 -->
              <div class="question-group">
                <label class="question-label">
                  <span class="question-number">4</span>
                  El nivel de detalle de los gráficos me parece:
                </label>
                <div class="radio-options single-column">
                  <label class="radio-option">
                    <input type="radio" v-model="answers.graph_detail" value="sufficient" name="graph_detail">
                    <span class="radio-custom"></span>
                    <span class="option-text">Suficiente</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="answers.graph_detail" value="too_basic" name="graph_detail">
                    <span class="radio-custom"></span>
                    <span class="option-text">Demasiado básico</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="answers.graph_detail" value="too_complex" name="graph_detail">
                    <span class="radio-custom"></span>
                    <span class="option-text">Demasiado complejo</span>
                  </label>
                </div>
              </div>

              <!-- Pregunta 5 -->
              <div class="question-group">
                <label class="question-label">
                  <span class="question-number">5</span>
                  Prefiero informes con:
                </label>
                <div class="radio-options single-column">
                  <label class="radio-option">
                    <input type="radio" v-model="answers.content_preference" value="more_analysis" name="content_preference">
                    <span class="radio-custom"></span>
                    <span class="option-text">Más análisis escrito</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="answers.content_preference" value="more_graphics" name="content_preference">
                    <span class="radio-custom"></span>
                    <span class="option-text">Más gráficos y visualizaciones</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="answers.content_preference" value="current_balance" name="content_preference">
                    <span class="radio-custom"></span>
                    <span class="option-text">Está bien como está</span>
                  </label>
                </div>
              </div>

              <!-- Pregunta 6 -->
              <div class="question-group">
                <label class="question-label">
                  <span class="question-number">6</span>
                  ¿Qué opinas de la longitud del informe?
                </label>
                <div class="radio-options single-column">
                  <label class="radio-option">
                    <input type="radio" v-model="answers.report_length" value="too_long" name="report_length">
                    <span class="radio-custom"></span>
                    <span class="option-text">Demasiado largo</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="answers.report_length" value="adequate" name="report_length">
                    <span class="radio-custom"></span>
                    <span class="option-text">Adecuado</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="answers.report_length" value="too_short" name="report_length">
                    <span class="radio-custom"></span>
                    <span class="option-text">Demasiado corto</span>
                  </label>
                </div>
              </div>
            </div>

            <!-- Final open-ended question -->
            <div class="survey-section">
              <div class="question-group">
                <label class="question-label">
                  <span class="question-number">7</span>
                  ¿Hay algo más que quieras contarnos? (opcional)
                </label>
                <textarea
                  v-model="answers.additional_comments"
                  class="text-area"
                  placeholder="Tu comentario libre..."
                  rows="3">
                </textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer-gcn">
          <button class="btnGcn btnGcn-secondary" @click="closePopup">
            Cerrar
          </button>
          <button class="btnGcn btnGcn-primary" :disabled="!isFormValid" @click="submitAnswer">
            <span class="material-icons-outlined">send</span>
            Enviar Encuesta
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SurveyPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      answers: {
        favorite_section: '',
        favorite_section_other: '',
        least_useful_section: '',
        least_useful_section_other: '',
        future_section: '',
        graph_detail: '',
        content_preference: '',
        report_length: '',
        additional_comments: ''
      },
      sectionOptions: [
        { value: 'valores_destacados', label: 'Valores destacados' },
        { value: 'sabias_que', label: '¿Sabías qué?' },
        { value: 'dicho_del_dia', label: 'Dicho del día' },
        { value: 'direccionalidad', label: 'Direccionalidad' },
        { value: 'acciones_rentables', label: 'Acciones rentables' },
        { value: 'video', label: 'Vídeo' },
        { value: 'satira_bursatil', label: 'Sátira bursátil' }
      ]
    }
  },
  computed: {
    isFormValid() {
      return !!(
        this.answers.favorite_section && 
        this.answers.least_useful_section && 
        this.answers.graph_detail && 
        this.answers.content_preference && 
        this.answers.report_length
      );
    }
  },
  methods: {
    submitAnswer () {
      if (this.isFormValid) {
        // Clean up the answers object
        const cleanAnswers = { ...this.answers };
        
        // If "other" was selected but no text provided, clear the other field
        if (cleanAnswers.favorite_section === 'other' && !cleanAnswers.favorite_section_other) {
          cleanAnswers.favorite_section_other = '';
        }
        if (cleanAnswers.least_useful_section === 'other' && !cleanAnswers.least_useful_section_other) {
          cleanAnswers.least_useful_section_other = '';
        }
        
        this.$emit('submitted', cleanAnswers);
      }
    },
    closePopup () {
      this.$emit('closed');
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
        // Reset form when reopened
        this.answers = {
          favorite_section: '',
          favorite_section_other: '',
          least_useful_section: '',
          least_useful_section_other: '',
          future_section: '',
          graph_detail: '',
          content_preference: '',
          report_length: '',
          additional_comments: ''
        };
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  beforeDestroy() {
    if (this.show) {
      document.body.style.overflow = '';
    }
  }
}
</script>

<style scoped>
/* Modal Transition Effects */
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-container-gcn,
.modal-fade-leave-active .modal-container-gcn {
  transition: transform 0.3s ease;
}
.modal-fade-enter .modal-container-gcn,
.modal-fade-leave-to .modal-container-gcn {
  transform: translateY(-30px);
}

/* Modal Base Styles (matching GestionCartera) */
.modal-overlay-gcn {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.modal-container-gcn {
  background-color: var(--color-surface);
  padding: 28px 32px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  border: 1px solid var(--color-outline);
}

.modal-container-gcn.modal-lg {
  max-width: 700px;
}

.modal-header-gcn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-outline);
  padding-bottom: 16px;
  margin-bottom: 24px;
}

.modal-header-gcn h3 {
  margin: 0;
  font-size: 1.4em;
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-icon {
  color: var(--color-highlight);
  font-size: 1.2em;
}

.modal-close-btnGcn {
  background: none;
  border: none;
  font-size: 1.8em;
  line-height: 1;
  cursor: pointer;
  color: var(--color-text-secondary);
  padding: 0 5px;
  transition: color 0.2s ease;
}

.modal-close-btnGcn:hover {
  color: var(--color-text-primary);
}

.modal-body-gcn {
  margin-bottom: 24px;
}

.modal-footer-gcn {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid var(--color-outline);
  gap: 12px;
}

/* Survey-specific Styles */
.survey-content {
  text-align: left;
}

.survey-intro {
  font-size: 1em;
  color: var(--color-text-secondary);
  margin-bottom: 24px;
  text-align: center;
  font-style: italic;
}

.survey-section {
  margin-bottom: 32px;
  padding: 20px;
  background-color: var(--color-background);
  border-radius: 8px;
  border: 1px solid var(--color-outline);
}

.section-title {
  font-size: 1.2em;
  color: var(--color-text-primary);
  margin: 0 0 20px 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-icon {
  font-size: 1.1em;
}

.question-group {
  margin-bottom: 24px;
}

.question-label {
  display: block;
  font-size: 1em;
  font-weight: 500;
  color: var(--color-text-primary);
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.question-number {
  background-color: var(--color-highlight);
  color: var(--color-text-on-highlight);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85em;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 2px;
}

.radio-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px 24px;
  max-width: 100%;
  margin: 0 20px;
}

.radio-options.single-column {
  grid-template-columns: 1fr;
  max-width: 300px;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 12px 16px;
  transition: all 0.2s ease;
  position: relative;
  font-size: 0.95em;
  background-color: var(--color-active-surface);
  border-radius: 6px;
  border: 1px solid var(--color-outline);
}

.radio-option:hover {
  transform: translateX(2px);
  background-color: var(--color-highlight);
  color: var(--color-text-on-highlight);
  border-color: var(--color-highlight);
}

.radio-option:hover .option-text {
  color: var(--color-text-on-highlight);
}

.radio-option:has(input[type="radio"]:checked) {
  background-color: var(--color-highlight);
  color: var(--color-text-on-highlight);
  border-color: var(--color-highlight);
  box-shadow: 0 2px 4px rgba(0, 173, 217, 0.2);
}

.radio-option:has(input[type="radio"]:checked) .option-text {
  color: var(--color-text-on-highlight);
  font-weight: 500;
}

.radio-option input[type="radio"] {
  width: 18px;
  height: 18px;
  margin: 0;
  cursor: pointer;
  opacity: 1;
  position: relative;
  flex-shrink: 0;
}

.radio-custom {
  display: none;
}

.option-text {
  color: var(--color-text-primary);
  font-size: 0.95em;
  font-weight: 400;
  transition: color 0.2s ease;
  flex: 1;
}

.other-input {
  margin-left: 8px;
  padding: 4px 8px;
  border: 1px solid var(--color-outline);
  border-radius: 4px;
  background-color: var(--color-surface);
  color: var(--color-text-primary);
  font-size: 0.9em;
  flex: 1;
  min-width: 120px;
  max-width: 200px;
}

.other-input:focus {
  outline: none;
  border-color: var(--color-highlight);
  box-shadow: 0 0 0 2px rgba(0, 173, 217, 0.2);
}

.text-area {
  width: calc(100% - 40px);
  margin: 0 20px;
  padding: 12px;
  border: 1px solid var(--color-outline);
  border-radius: 6px;
  background-color: var(--color-surface);
  color: var(--color-text-primary);
  font-size: 0.95em;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
  box-sizing: border-box;
}

.text-area:focus {
  outline: none;
  border-color: var(--color-highlight);
  box-shadow: 0 0 0 2px rgba(0, 173, 217, 0.2);
}

.text-area::placeholder {
  color: var(--color-text-inactive);
}

/* Button Styles (matching GestionCartera) */
.btnGcn {
  background-color: var(--color-highlight);
  color: var(--color-text-on-highlight);
  border: 1px solid var(--color-highlight);
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.95em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 90px;
  justify-content: center;
}

.btnGcn:hover:not(:disabled) {
  background-color: var(--color-text-primary);
  color: var(--color-background);
  border-color: var(--color-text-primary);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.btnGcn:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.btnGcn:focus {
  outline: none;
  box-shadow: 0 0 0 3px var(--color-active-surface);
}

.btnGcn-secondary {
  background-color: var(--color-surface);
  color: var(--color-text-primary);
  border: 1px solid var(--color-outline);
}

.btnGcn-secondary:hover:not(:disabled) {
  background-color: var(--color-active-surface);
  border-color: var(--color-text-secondary);
  transform: none;
  box-shadow: none;
}

.btnGcn-primary {
  background-color: var(--color-highlight);
  color: var(--color-text-on-highlight);
  border: 1px solid var(--color-highlight);
}

.btnGcn:disabled {
  background-color: var(--color-surface);
  color: var(--color-text-inactive);
  border-color: var(--color-outline);
  cursor: not-allowed;
  opacity: 0.6;
  transform: none !important;
  box-shadow: none !important;
}

.btnGcn .material-icons-outlined {
  font-size: 1.1em;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-container-gcn {
    padding: 20px 24px;
    margin: 20px;
    width: calc(100% - 40px);
    max-height: 85vh;
  }
  
  .modal-header-gcn h3 {
    font-size: 1.2em;
  }
  
  .survey-section {
    padding: 16px;
    margin-bottom: 24px;
  }
  
  .question-label {
    font-size: 0.95em;
  }
  
  .radio-options {
    margin-left: 20px;
    gap: 8px 16px;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
  
  .radio-option {
    padding: 10px 12px;
    font-size: 0.9em;
  }
  
  .radio-option input[type="radio"] {
    width: 16px;
    height: 16px;
  }
  
  .text-area {
    margin-left: 20px;
    width: calc(100% - 20px);
  }
  
  .other-input {
    min-width: 100px;
    max-width: 150px;
  }
  
  .modal-footer-gcn {
    flex-direction: column-reverse;
    gap: 8px;
  }
  
  .btnGcn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .radio-options {
    margin-left: 10px;
    gap: 6px 12px;
    grid-template-columns: 1fr;
  }
  
  .radio-option {
    padding: 8px 10px;
    font-size: 0.85em;
  }
  
  .radio-option input[type="radio"] {
    width: 14px;
    height: 14px;
  }
  
  .question-label {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .question-number {
    width: 20px;
    height: 20px;
    font-size: 0.75em;
  }
  
  .text-area {
    margin-left: 10px;
    width: calc(100% - 10px);
  }
}
</style> 